import { Model } from 'vuex-orm';

import User from '../user/model';

export default class Version extends Model {
  static entity = 'versions';

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      item_type: this.attr(''),
      item_id: this.attr(''),
      event: this.attr(''),
      model: this.attr(''),
      created_at: this.attr(''),

      user: this.belongsTo(User, 'user_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/version/model.js